// YERİ: src/app/domains/website/sections/mkt-consent-banner.ts
//
// Cookie consent bar for melbarrel.com (platform storefront only — mounted in
// WebLayout; tenant sites use a different shell and never render it).
//
// Two equal-weight choices ("Tümünü kabul et" / "Yalnızca zorunlu"): rejecting
// must be as easy as accepting. Nothing renders on the server — the decision
// lives in the visitor's browser, and an SSR-painted bar would flash for
// visitors who already decided.

import { isPlatformBrowser } from '@angular/common';
import { afterNextRender, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LanguageStore } from '../core/language.store';
import { MktChromeText } from '../core/mkt-chrome-text';
import { TrackingConsentStore } from '../core/tracking-consent.store';

@Component({
  selector: 'mkt-consent-banner',
  standalone: true,
  imports: [RouterLink],
  template: `
    @if (visible()) {
      <div role="region" [attr.aria-label]="text.t('consentLabel')"
        class="fixed inset-x-0 bottom-0 z-[60] border-t border-[color:var(--mkt-border)] bg-[color:var(--mkt-surface)] shadow-[0_-8px_30px_rgba(0,0,0,0.08)]"
        [attr.dir]="lang.dir()">
        <div class="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:gap-6 sm:px-8">
          <p class="flex-1 text-[0.8125rem] leading-relaxed text-[color:var(--mkt-text-muted)]">
            {{ text.t('consentText') }}
            <a class="whitespace-nowrap font-medium text-[color:var(--mkt-accent)] underline underline-offset-2"
              [routerLink]="['/', lang.current(), 'legal', 'cookies']">{{ text.t('consentLearnMore') }}</a>
          </p>
          <div class="flex shrink-0 gap-2">
            <button type="button" class="mkt-btn mkt-btn-secondary flex-1 sm:flex-none" (click)="consent.rejectAll()">
              {{ text.t('consentReject') }}
            </button>
            <button type="button" class="mkt-btn mkt-btn-primary flex-1 sm:flex-none" (click)="consent.acceptAll()">
              {{ text.t('consentAccept') }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class MktConsentBanner {
  protected consent = inject(TrackingConsentStore);
  protected text = inject(MktChromeText);
  protected lang = inject(LanguageStore);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  protected visible = computed(() => this.isBrowser && this.consent.bannerVisible());

  constructor() {
    // Browser only, after hydration: storage + tag config are client concerns.
    afterNextRender(() => this.consent.init());
  }
}
